import CompleteInspection from './CompleteInspection';
import StartInspection from './StartInspection';
import EditInspection from './EditInspection';

export default { CompleteInspection, StartInspection, EditInspection };
